(() => {
  const qs = (sel, root = document) => root.querySelector(sel);
  const qsa = (sel, root = document) => Array.from(root.querySelectorAll(sel));
  const money = (cents) => {
    if (window.Shopify && typeof Shopify.formatMoney === 'function') {
      return Shopify.formatMoney(cents, window.themeVariables?.settings?.moneyFormat || '${{amount}}');
    }
    return new Intl.NumberFormat(document.documentElement.lang || 'en', { style: 'currency', currency: 'EUR' }).format((cents || 0) / 100);
  };

  const open = (name) => {
    const el = qs(`[data-sm-overlay="${name}"]`);
    if (!el) return;
    el.classList.add('is-open');
    el.removeAttribute('aria-hidden');
    const focus = qs('[data-sm-autofocus]', el);
    if (focus) setTimeout(() => focus.focus(), 80);
    document.documentElement.style.overflow = 'hidden';
  };

  const close = (name) => {
    const el = typeof name === 'string' ? qs(`[data-sm-overlay="${name}"]`) : name;
    if (!el) return;
    el.classList.remove('is-open');
    el.setAttribute('aria-hidden', 'true');
    if (!qs('.sm-overlay.is-open, .sm-drawer.is-open')) {
      document.documentElement.style.overflow = '';
    }
  };

  qsa('[data-sm-open]').forEach((button) => {
    button.addEventListener('click', (event) => {
      event.preventDefault();
      const current = button.closest('[data-sm-overlay].is-open');
      if (current && current.dataset.smOverlay !== button.dataset.smOpen) close(current);
      open(button.dataset.smOpen);
      if (button.dataset.smContactSubject) {
        const field = qs('[data-sm-contact-subject-field]');
        if (field) field.value = button.dataset.smContactSubject;
      }
    });
  });
  qsa('[data-sm-close]').forEach((button) => {
    button.addEventListener('click', () => close(button.dataset.smClose || button.closest('[data-sm-overlay]')));
  });
  qsa('.sm-drawer__shade, .sm-overlay__shade, .sm-modal__shade').forEach((shade) => {
    shade.addEventListener('click', () => close(shade.closest('[data-sm-overlay]')));
  });
  document.addEventListener('keydown', (event) => {
    if (event.key === 'Escape') qsa('[data-sm-overlay].is-open').forEach(close);
  });

  const desktopMenu = () => window.matchMedia('(min-width: 981px)').matches;
  const closeMegas = (except = null) => {
    qsa('.sm-nav-item.is-open').forEach((item) => {
      if (item !== except) {
        item.classList.remove('is-open');
        const trigger = item.querySelector(':scope > a, :scope > button');
        if (trigger) trigger.setAttribute('aria-expanded', 'false');
      }
    });
  };
  qsa('.sm-header__nav .sm-nav-item').forEach((item) => {
    const trigger = item.querySelector(':scope > a, :scope > button');
    const panel = item.querySelector(':scope > .sm-mega');
    if (!trigger || !panel) return;

    let closeTimer;
    trigger.setAttribute('aria-haspopup', 'true');
    trigger.setAttribute('aria-expanded', 'false');

    const openMega = () => {
      if (!desktopMenu()) return;
      clearTimeout(closeTimer);
      closeMegas(item);
      item.classList.add('is-open');
      trigger.setAttribute('aria-expanded', 'true');
    };
    const queueClose = () => {
      clearTimeout(closeTimer);
      closeTimer = setTimeout(() => closeMegas(), 180);
    };

    item.addEventListener('mouseenter', openMega);
    item.addEventListener('mouseleave', queueClose);
    item.addEventListener('focusin', openMega);
    item.addEventListener('focusout', () => {
      closeTimer = setTimeout(() => {
        if (!item.contains(document.activeElement)) closeMegas();
      }, 120);
    });
    trigger.addEventListener('click', (event) => {
      if (!desktopMenu()) return;
      event.preventDefault();
      openMega();
    });
  });
  document.addEventListener('click', (event) => {
    if (!event.target.closest('.sm-nav-item')) closeMegas();
  });
  document.addEventListener('keydown', (event) => {
    if (event.key === 'Escape') closeMegas();
  });

  qsa('[data-sm-rail]').forEach((rail) => {
    const id = rail.dataset.smRail;
    qsa(`[data-sm-rail-control="${id}"]`).forEach((button) => {
      button.addEventListener('click', () => {
        rail.scrollBy({ left: (button.dataset.direction === 'prev' ? -1 : 1) * 360, behavior: 'smooth' });
      });
    });
  });

  qsa('[data-sm-grid-cols]').forEach((button) => {
    button.addEventListener('click', () => {
      const grid = qs('[data-sm-product-grid]');
      if (!grid) return;
      grid.dataset.cols = button.dataset.smGridCols;
      qsa('[data-sm-grid-cols]').forEach((b) => b.setAttribute('aria-pressed', b === button ? 'true' : 'false'));
    });
  });

  qsa('[data-sm-filter-toggle]').forEach((button) => {
    button.addEventListener('click', () => {
      const panel = qs('[data-sm-filter-panel]');
      if (!panel) return;
      const isOpen = panel.classList.toggle('is-open');
      button.setAttribute('aria-expanded', String(isOpen));
    });
  });

  const getWishlist = () => {
    try { return JSON.parse(localStorage.getItem('solenne_wishlist') || '[]'); }
    catch (_) { return []; }
  };
  const setWishlist = (items) => {
    try { localStorage.setItem('solenne_wishlist', JSON.stringify(items)); } catch (_) {}
    renderWishlist();
  };
  const productDataFromButton = (button) => ({
    id: button.dataset.productId,
    title: button.dataset.productTitle,
    url: button.dataset.productUrl,
    image: button.dataset.productImage,
    price: button.dataset.productPrice,
  });
  const syncWishlistButtons = () => {
    const ids = getWishlist().map((item) => String(item.id));
    qsa('[data-sm-wishlist]').forEach((button) => {
      const active = ids.includes(String(button.dataset.productId));
      button.classList.toggle('is-active', active);
      button.setAttribute('aria-pressed', String(active));
    });
    qsa('[data-sm-wishlist-count]').forEach((badge) => {
      badge.textContent = ids.length;
      badge.hidden = ids.length === 0;
    });
  };
  const renderWishlist = () => {
    const items = getWishlist();
    const body = qs('[data-sm-wishlist-body]');
    if (body) {
      body.innerHTML = items.length ? items.map((item) => `
        <div class="sm-cart-line">
          <a class="sm-cart-line__image" href="${item.url || '#'}">${item.image ? `<img src="${item.image}" alt="">` : ''}</a>
          <div class="sm-cart-line__main">
            <div class="sm-cart-line__top">
              <a class="sm-cart-line__title" href="${item.url || '#'}">${item.title || 'Saved piece'}</a>
              <button type="button" data-sm-wishlist-remove="${item.id}" aria-label="Remove">${icon('close')}</button>
            </div>
            <span class="sm-price">${item.price || ''}</span>
            <a class="sm-btn sm-btn--outline sm-btn--sm" href="${item.url || '#'}">View piece</a>
          </div>
        </div>
      `).join('') : `
        <div class="sm-empty">
          <h3>No favourites yet</h3>
          <p>Tap the heart on any piece to save it here.</p>
          <a class="sm-btn sm-btn--solid" href="/collections/all">Browse jewellery</a>
        </div>
      `;
    }
    syncWishlistButtons();
  };

  document.addEventListener('click', (event) => {
    const button = event.target.closest('[data-sm-wishlist]');
    if (button) {
      event.preventDefault();
      event.stopPropagation();
      const item = productDataFromButton(button);
      const current = getWishlist();
      const exists = current.some((saved) => String(saved.id) === String(item.id));
      setWishlist(exists ? current.filter((saved) => String(saved.id) !== String(item.id)) : [...current, item]);
    }
    const remove = event.target.closest('[data-sm-wishlist-remove]');
    if (remove) {
      setWishlist(getWishlist().filter((item) => String(item.id) !== String(remove.dataset.smWishlistRemove)));
    }
  });

  const cartLine = (item) => {
    const variantTitle = item.variant_title && item.variant_title !== 'Default Title' ? item.variant_title : '';

    return `
      <div class="sm-cart-line">
        <a class="sm-cart-line__image" href="${item.url}">${item.image ? `<img src="${item.image}" alt="">` : ''}</a>
        <div class="sm-cart-line__main">
          <div class="sm-cart-line__top">
            <a class="sm-cart-line__title" href="${item.url}">${item.product_title}</a>
            <button type="button" data-sm-cart-remove="${item.key}" aria-label="Remove">${icon('close')}</button>
          </div>
          ${variantTitle ? `<span class="sm-cart-line__variant">${variantTitle}</span>` : ''}
          <div class="sm-cart-line__top" style="align-items:center;margin-top:4px">
            <div class="sm-stepper">
              <button type="button" data-sm-cart-qty="${item.key}" data-qty="${Math.max(0, item.quantity - 1)}">${icon('minus')}</button>
              <input value="${item.quantity}" inputmode="numeric" aria-label="Quantity" readonly>
              <button type="button" data-sm-cart-qty="${item.key}" data-qty="${item.quantity + 1}">${icon('plus')}</button>
            </div>
            <span class="sm-price">${money(item.final_line_price)}</span>
          </div>
        </div>
      </div>
    `;
  };

  const renderCart = (cart) => {
    qsa('[data-sm-cart-count]').forEach((badge) => {
      badge.textContent = cart.item_count;
      badge.hidden = cart.item_count === 0 && !badge.hasAttribute('data-sm-cart-count-visible');
    });
    qsa('[data-sm-cart-body]').forEach((body) => {
      body.innerHTML = cart.items.length ? cart.items.map(cartLine).join('') : `
        <div class="sm-empty">
          <h3>Your bag is empty</h3>
          <p>Beautiful things are waiting.</p>
          <a class="sm-btn sm-btn--solid" href="/collections/all">Start shopping</a>
        </div>
      `;
    });
    qsa('[data-sm-free-label]').forEach((label) => {
      label.textContent = 'Delivery options, costs and taxes are confirmed at checkout.';
    });
    qsa('[data-sm-cart-subtotal]').forEach((el) => { el.textContent = money(cart.total_price); });
    qsa('[data-sm-checkout-label]').forEach((el) => { el.textContent = `Checkout - ${money(cart.total_price)}`; });
  };

  const fetchCart = async () => {
    const response = await fetch('/cart.js', { headers: { Accept: 'application/json' } });
    if (!response.ok) throw new Error('Cart fetch failed');
    const cart = await response.json();
    renderCart(cart);
    return cart;
  };

  const changeCart = async (key, quantity) => {
    const response = await fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ id: key, quantity }),
    });
    if (!response.ok) throw new Error('Cart change failed');
    renderCart(await response.json());
  };

  document.addEventListener('click', (event) => {
    const qty = event.target.closest('[data-sm-cart-qty]');
    if (qty) {
      event.preventDefault();
      changeCart(qty.dataset.smCartQty, Number(qty.dataset.qty));
    }
    const remove = event.target.closest('[data-sm-cart-remove]');
    if (remove) {
      event.preventDefault();
      changeCart(remove.dataset.smCartRemove, 0);
    }
  });

  const addVariants = async (ids, button) => {
    const variants = ids.map((id) => String(id).trim()).filter(Boolean);
    if (!variants.length) return;
    const original = button ? button.textContent : '';
    if (button) {
      button.disabled = true;
      button.textContent = variants.length > 1 ? 'Adding look...' : 'Adding...';
    }
    try {
      const response = await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: variants.map((id) => ({ id: Number(id), quantity: 1 })) }),
      });
      if (!response.ok) throw new Error('Add variants failed');
      await response.json();
      await fetchCart();
      qsa('[data-sm-overlay].is-open').forEach(close);
      open('cart');
      if (button) button.textContent = 'Added';
      setTimeout(() => { if (button) button.textContent = original; }, 1400);
    } catch (error) {
      if (button) button.textContent = 'Try again';
    } finally {
      if (button) setTimeout(() => { button.disabled = false; }, 500);
    }
  };

  document.addEventListener('click', (event) => {
    const single = event.target.closest('[data-sm-add-variant]');
    if (single) {
      event.preventDefault();
      addVariants([single.dataset.smAddVariant], single);
    }
    const bulk = event.target.closest('[data-sm-add-variants]');
    if (bulk) {
      event.preventDefault();
      addVariants((bulk.dataset.smAddVariants || '').split(','), bulk);
    }
  });

  qsa('[data-sm-show-reviews]').forEach((button) => {
    button.addEventListener('click', () => {
      qsa('[data-sm-review-extra]').forEach((card) => { card.hidden = false; });
      button.hidden = true;
    });
  });

  qsa('[data-sm-product-form]').forEach((form) => {
    form.addEventListener('submit', async (event) => {
      event.preventDefault();
      const button = qs('[type="submit"]', form);
      const original = button ? button.textContent : '';
      if (button) {
        button.disabled = true;
        button.textContent = 'Adding...';
      }
      try {
        const response = await fetch('/cart/add.js', {
          method: 'POST',
          headers: { Accept: 'application/json' },
          body: new FormData(form),
        });
        if (!response.ok) throw new Error('Add to cart failed');
        await response.json();
        await fetchCart();
        open('cart');
        if (button) button.textContent = 'Added to bag';
        setTimeout(() => { if (button) button.textContent = original; }, 1400);
      } catch (error) {
        if (button) button.textContent = 'Try again';
      } finally {
        if (button) setTimeout(() => { button.disabled = false; }, 500);
      }
    });
  });

  qsa('[data-sm-product-root]').forEach((root) => {
    const json = qs('[data-sm-product-json]', root);
    if (!json) return;
    let product;
    try { product = JSON.parse(json.textContent); } catch (_) { return; }
    const variantInput = qs('[name="id"]', root);
    const price = qs('[data-sm-product-price]', root);
    const add = qs('[data-sm-product-add]', root);
    const main = qs('[data-sm-main-image]', root);
      const updateVariant = () => {
        const selected = product.options.map((option, index) => {
          const checked = qs(`[name="option-${index}"]:checked`, root);
          if (checked) return checked.value;
          return Array.isArray(option.values) ? option.values[0] : option;
        });
      const variant = product.variants.find((candidate) => selected.every((value, index) => candidate.options[index] === value));
      if (!variant) return;
      if (variantInput) variantInput.value = variant.id;
      if (price) price.textContent = money(variant.price);
      if (add) {
        add.disabled = !variant.available;
        add.textContent = variant.available ? `Add to bag - ${money(variant.price)}` : 'Sold out';
      }
    };
    qsa('[data-sm-product-option]', root).forEach((input) => input.addEventListener('change', updateVariant));
    qsa('[data-sm-thumb]', root).forEach((button) => {
      button.addEventListener('click', () => {
        const img = qs('img', button);
        if (!img || !main) return;
        qsa('[data-sm-thumb]', root).forEach((thumb) => thumb.classList.toggle('is-active', thumb === button));
        main.innerHTML = `<img src="${img.dataset.full || img.src}" alt="${img.alt || ''}">`;
      });
    });
    updateVariant();
  });

  qsa('[data-sm-search-form]').forEach((form) => {
    const input = qs('[data-sm-search-input]', form);
    const results = qs('[data-sm-search-results]');
    let timer;
    if (!input || !results) return;
    const initialResults = results.innerHTML;
    input.addEventListener('input', () => {
      clearTimeout(timer);
      const q = input.value.trim();
      if (!q) {
        results.innerHTML = initialResults;
        return;
      }
      timer = setTimeout(async () => {
        const url = `/search/suggest.json?q=${encodeURIComponent(q)}&resources[type]=product&resources[limit]=6`;
        const response = await fetch(url, { headers: { Accept: 'application/json' } });
        if (!response.ok) return;
        const data = await response.json();
        const products = data.resources?.results?.products || [];
        results.innerHTML = products.length ? products.map((product) => `
          <a class="sm-card" href="${product.url}">
            <span class="sm-card__media">${product.image ? `<img src="${product.image}" alt="">` : ''}</span>
            <span class="sm-card__meta">
              <span class="sm-card__title">${product.title}</span>
              <span class="sm-price">${product.price || ''}</span>
            </span>
          </a>
        `).join('') : '<p class="sm-empty">No results yet.</p>';
      }, 160);
    });
  });

  qsa('[data-sm-popup]').forEach((popup) => {
    if (localStorage.getItem('solenne_newsletter_dismissed')) return;
    setTimeout(() => popup.classList.add('is-open'), 1400);
  });
  qsa('[data-sm-popup-close]').forEach((button) => {
    button.addEventListener('click', () => {
      localStorage.setItem('solenne_newsletter_dismissed', '1');
      button.closest('[data-sm-popup]')?.classList.remove('is-open');
    });
  });

  function icon(name) {
    const paths = {
      close: '<path d="M6 6l12 12M18 6 6 18"/>',
      plus: '<path d="M12 5v14M5 12h14"/>',
      minus: '<path d="M5 12h14"/>',
    };
    return `<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.7" stroke-linecap="round">${paths[name] || ''}</svg>`;
  }

  renderWishlist();
  fetchCart().catch(() => {});
})();
